module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TGT9H5B","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"variant":"master"}},"routeChangeEventName":"gatsby-route-change","selfHostedOrigin":"https://ss.hackk.dk","selfHostedPath":"ejsvkjlgk.js?a9o=aWQ9R1RNLVRHVDlINUI=&page=1","enableWebVitalsTracking":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"hackk.dk","short_name":"hackk","start_url":"/","background_color":"#eeeeee","theme_color":"#1f1f1f","display":"minimal-ui","icon":"src/images/gatsby-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0e3e31acd00455ab4c29d47b58d61908"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
